import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=64d4f078&scoped=true&"
import script from "./BaseSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=64d4f078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4f078",
  null
  
)

export default component.exports